const UPLOAD_FILENAME_PATTERN =
  /^\.\/(?<timestamp>\d{4}-\d{2}-\d{2}T\d{6})(?:[A-Za-z0-9_-]*)\.[a-z0-9]+$/i;

function getUploadTimestamp(key) {
  return key.match(UPLOAD_FILENAME_PATTERN)?.groups?.timestamp || null;
}

export function sortGalleryKeys(keys) {
  return [...keys].sort((left, right) => {
    const leftTimestamp = getUploadTimestamp(left);
    const rightTimestamp = getUploadTimestamp(right);

    if (leftTimestamp && rightTimestamp) {
      return rightTimestamp.localeCompare(leftTimestamp);
    }

    if (leftTimestamp) {
      return -1;
    }

    if (rightTimestamp) {
      return 1;
    }

    return left.localeCompare(right);
  });
}

export function loadGalleryImages(context) {
  return sortGalleryKeys(context.keys()).map((key) => ({
    key,
    src: context(key),
  }));
}
